export module WarlockStatics {
	export namespace WarlockAPI {
		export const s_StorageUploadReq: string = "storageuploadreq";
		export const s_BRDUpdateReq: string = "brdupdatereq";
	}
}
